import axios from 'axios';
import config from '~/config';
import * as customError from '~/models/error'

export const useQuranStore = defineStore('quran', {
    state: () => ({
        listOrthography: [],
        listQari: [],
        listVoice: []
    }),
    actions: {
        async getOrthographyList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/quran/ListOrthography`;
                const requestParams = {
                    language: params
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.listOrthography = serviceResult.data.Data;
                return this.listOrthography;
            } catch (err) {
                console.log({ err })
            }
        },
        async getQariList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/quran/ListRecitor`;
                const requestParams = {
                    language: params.language,
                    surahId: params.surah.Id
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.listQari = serviceResult.data.Data;
                return this.listQari;
            } catch (err) {
                console.log({ err })
            }
        },
        async getVoiceList(params) {
            try {
                const url = `${config.API_BASE_URL}/api/quran/RecitationList`;
                const requestParams = {
                    recitorId: params.recitorId,
                    surahId: params.surahId
                }
                const serviceResult = await axios.get(url, { params: requestParams });
                if (!serviceResult?.data?.Data?.length)
                    throw new customError.NoContent(serviceResult, url)
                this.listVoice = serviceResult.data.Data;
                return this.listVoice;
            } catch (err) {
                console.log({ err })
            }
        },
    },
})